import React, { Component } from 'react';
import {
    Container, Button, Form, Header
} from "semantic-ui-react";
import { toastStyle } from '../../Config';
import { checkAuth, getUserByEmail } from '../../services';
import { Toaster, toast } from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';
import CustomForm from '../Form/CustomForm';

class Auth extends React.PureComponent {

    constructor(props) {
        super(props);
        this.initialState = {
            ButtonLoader: false,
            buttonDisabled: true,
            uiVisble: false,
            userEmail: '',
            validated: false,
            disabled: true,
            orgCode: '',
            ownerId: '',
            ownerEmail: ''

        };
        this.state = this.initialState;
    }

    handleChangedValue = (e) => {
        let newState = { ...this.state }
        newState = ({
            ...newState, [e.target.name]: e.target.value
        });
        newState.userEmail ? newState.disabled = false : newState.disabled = true;
        this.setState(newState);
    };



    onSubmitClick = (e) => {
        e.preventDefault();
        this.setState({ ButtonLoader: true })

        if (this.state.userEmail) {

            getUserByEmail({ 'email': encodeURIComponent(this.state.userEmail) }).then(res => {
                //console.log('res', res.data.message)
                let response = res.data.message;
                if (response.length > 0) {

                    checkAuth({ 'teamId': response[0]['TeamId'] }).then(res => {
                        //console.log('res', res.data.message)
                        let result = res.data.message;
                        if (result.length > 0) {
                            this.setState({ uiVisble: true, ButtonLoader: false, validated: true, orgCode: response[0]['OrgId'], ownerId: response[0]['UserId'], ownerEmail: response[0]['EmailAddress'] })
                        }
                        else {
                            toast.error(`User not Authorized`, { position: "top-right", duration: 2000, style: toastStyle });
                            this.setState({ ButtonLoader: false })

                        }

                    }).catch(error => {
                        toast.error(`Error while Checking auth - ${error}`, { position: "top-right", duration: 2000, style: toastStyle });
                        this.setState({ ButtonLoader: false })
                    });

                }
                else {
                    toast.error(`User not Authorized`, { position: "top-right", duration: 2000, style: toastStyle });
                    this.setState({ ButtonLoader: false })

                }

            }).catch(error => {
                toast.error(`Error while Checking auth - ${error}`, { position: "top-right", duration: 2000, style: toastStyle });
                this.setState({ ButtonLoader: false })
            });
        }
    }


    render() {
        //console.log('state in Auth=======>', this.state)
        return (
            <div>

                <Container textAlign='center' className="custom-container">
                    {this.state.validated == false ? <> <Header as='h3' icon dividing color="blue" className="custom-header">
                        <Header.Content>Authentication</Header.Content>
                    </Header>

                        <Form size='large' onSubmit={this.onSubmitClick}>
                            <Form.Group widths='equal'>
                                <Form.Field>
                                    <label className='custom-label'>User LS Email Address</label>
                                </Form.Field>
                                <Form.Field
                                    control='input'
                                    type="email"
                                    value={this.state.userEmail}
                                    onChange={(e) => { this.handleChangedValue(e) }}
                                    name='userEmail'

                                />
                            </Form.Group>

                            <Button size='large' primary className="custom-container-btn" loading={this.state.ButtonLoader} disabled={this.state.disabled}>Submit</Button>

                        </Form></> :
                        <CustomForm orgCode={this.state.orgCode} ownerEmail={this.state.ownerEmail} ownerId={this.state.ownerId} />}
                    <Toaster limit={1} />
                </Container>
            </div>
        );
    }
}

export default Auth;